module.exports = __webpack_public_path__ + "static/img/cop_sch_logo22.794d9837.png";